import { Facebook, Instagram, Youtube, MessageCircle, Music, Globe } from 'lucide-react';

/* Ícone por rede — o `icon` vem do catálogo de /producer-profiles/options,
   compartilhado com o de estabelecimentos. */
export const SOCIAL_ICONS = {
    facebook: Facebook,
    youtube: Youtube,
    instagram: Instagram,
    site: Globe,
    whatsapp: MessageCircle,
    tiktok: Music,
};

export function safeWebsiteHref(url) {
    if (!url) return null;
    if (/^javascript:/i.test(url)) return null;
    if (/^https?:\/\//i.test(url)) return url;
    return `https://${url}`;
}

export function buildSocialLinks(socialMedia) {
    return (socialMedia || [])
        .map(social => ({
            key: String(social.id),
            Icon: SOCIAL_ICONS[social.icon?.toLowerCase()] || Globe,
            label: social.name,
            href: safeWebsiteHref(social.url),
        }))
        .filter(social => social.href);
}
